var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTailRightNoPadding = function SvgArrowTailRightNoPadding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34393 5.00031L6.6569 5.00169L6.6569 1.00212L11.6571 6.00227L6.6569 11.0024V7.00147L1.34393 7.00009L1.34393 5.00031Z",
    fill: "currentColor"
  })));
};
export default SvgArrowTailRightNoPadding;